import styled from 'styled-components';

export const NoCamTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #000000;
    font-size: 16px;
    width: 100%;
`;
